import styled from "styled-components";
import * as React from "react";
import {Typography} from "antd";

const { Link} = Typography;

const StyledLink = styled(Link)`
    font-size: 1.125rem;
`;

const DisplayLink = ({linkObject}) => <StyledLink href={linkObject.url} target="_blank">{linkObject.title}</StyledLink>;

export default DisplayLink;
